// extracted by mini-css-extract-plugin
module.exports = {"thanks":"ThanksPage_thanks__2VuYQ","phoneHighlight":"ThanksPage_phoneHighlight__7V9K6"};